import "../Style/topNavbar.css";
import React, { useState } from "react";
import logo from "../Components/Images/logo.png";
import NavDrawer from "./NavDrawer";
import Resume from "./Amit-Sarah-Pal-Resume.pdf";

const TopNavbar = () => {
  const [current, setCurrent] = useState("#home");

  function handleClick() {
    // console.log("Invoked");
    window.open(Resume, "_blank");
  }

  return (
    <div>
      <div style={{ height: "10vh" }} id="topnav">
        <a href="#home">
          <div style={{ marginLeft: "40px", align: "center", padding: "4px" }}>
            <img width={"50px"} src={logo} alt="logo" />
          </div>
        </a>
        <div id="navel">
          <div onClick={() => [setCurrent("#home")]}>
            {" "}
            <a href="#home">
              <h4
                style={{ cursor: "pointer" }}
                className={current === "#home" ? "activemain" : null}
              >
                Home
              </h4>
            </a>{" "}
          </div>
          <div onClick={() => setCurrent("#about")}>
            <a href="#about">
              <h4
                style={{ cursor: "pointer" }}
                className={current === "#about" ? "activemain" : null}
              >
                About
              </h4>
            </a>{" "}
          </div>
          <div onClick={() => setCurrent("#skills")}>
            <a href="#skills">
              <h4
                style={{ cursor: "pointer" }}
                className={current === "#skills" ? "activemain" : null}
              >
                Skills
              </h4>
            </a>{" "}
          </div>
          <div onClick={() => setCurrent("#projects")}>
            <a href="#projects">
              <h4
                style={{ cursor: "pointer" }}
                className={current === "#projects" ? "activemain" : null}
              >
                Projects
              </h4>
            </a>{" "}
          </div>
          <div onClick={() => setCurrent("#contact")}>
            <a href="#contact">
              <h4
                style={{ cursor: "pointer" }}
                className={current === "#contact" ? "activemain" : null}
              >
                Contact
              </h4>
            </a>{" "}
          </div>
          <div onClick={() => setCurrent("#resume")}>
            <a
              target="blank"
              // href="https://drive.google.com/file/d/1_2s9ErkRxVp4JTG9P0QMX2Qi2gfoStfl/view?usp=sharing"
              href="Amit-Sarah-Pal-Resume.pdf"
              download={true}
            >
              <h4
                onClick={handleClick}
                style={{ cursor: "pointer" }}
                id="resumenav"
                className={current === "#resume" ? "activemain" : null}
              >
                Resume
              </h4>
            </a>{" "}
          </div>
        </div>
        <div id="sidebar">
          <NavDrawer />
        </div>
      </div>
    </div>
  );
};

export default TopNavbar;
